// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"637e390b","212":"16736ff3","273":"0b35cde4","316":"0bbe396e","564":"d1256de7","635":"16736ff3","776":"5d57baf6"}[chunkId] + ".chunk.css";
};